export const DATA_HOOK = {
  CHECKBOX: 'list-item-select-checkbox',
  PREFIX: 'list-item-select-prefix',
  SUFFIX: 'list-item-select-suffix',
  TITLE: 'list-item-select-title',
  SUBTITLE: 'list-item-select-subtitle',
  TOOLTIP: 'list-item-select-disabled-tooltip',
} as const;

export const SIZE = {
  small: 'small',
  medium: 'medium',
} as const;
